import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'prefix',
  standalone: true,
})
export class PrefixPipe implements PipeTransform {
  transform(value: string, prefix: string): string {
    if (!value) {
      return value;
    }

    return prefix + value;
  }
}
